// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3cvvO","dot-keyframes":"styles_dot-keyframes__2ysNi","container_light":"styles_container_light__2CILO"};